import { useDebounce } from "ahooks";
import { useState } from "react";

/**
 * Hook for debounced search functionality
 * @param wait - Debounce wait time in milliseconds
 * @returns Object containing search value, debounced search value, and change handler
 */
export default function useDebouncedSearch(wait = 300) {
  const [searchValue, setSearchValue] = useState("");

  const debouncedSearch = useDebounce(searchValue, { wait });

  return {
    debouncedSearch,
    onSearchChange: setSearchValue,
    searchValue,
  };
}
